module.exports = __webpack_public_path__ + "img/icon-payment-bbva.9782937e.png";